<template>
  <v-row>
    <v-col cols="12" md="2" class="d-flex" style="text-align: right">
      <v-menu
        offset-y
        v-model="filterForm.openMenu"
        bottom
        content-class="no-contain overflow-visible menu-filter-form-allotment"
        :close-on-content-click="false"
        >
          <template v-slot:activator="{ on }">
            <v-btn style="height: 36px;"
                   class="mb-2"
                   color="rgba(43, 1, 132, 0.5)"
                   dark v-on="on">
              <span>Tìm kiếm</span>
              <v-icon style="margin-left: 10px; margin-right: -20px;">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <template>
            <v-card
                class="overflow-visible my-0"
                width="400px"
                outlined
            >
              <v-list-item three-line class="pt-2">
                <validation-observer v-slot="{ handleSubmit }">
                  <v-list-item-content class="overflow-visible">
                    <v-row style="width: 100%; padding: 0px 20px">
                      <v-text-field
                          label="Tên lộ trình"
                          placeholder="Nhập tên lộ trình"
                          v-model="filterForm.name"
                          @keyup.enter.native="handleSubmit(searchAllotment)">
                      </v-text-field>
                    </v-row>

<!--                    <v-row style="width: 100%; padding: 0px 20px">-->
<!--                      <v-autocomplete-->
<!--                        v-model="filterForm.typeId"-->
<!--                        :items="listType"-->
<!--                        item-text="name"-->
<!--                        item-value="id"-->
<!--                        label="Chọn loại hình"-->
<!--                        :error-messages="errors"-->
<!--                      />-->
<!--                    </v-row>-->

<!--                    <v-row style="width: 100%; padding: 0px 20px">-->
<!--                      <v-autocomplete-->
<!--                        v-model="filterForm.schoolLevelId"-->
<!--                        :items="listSchoolLevel"-->
<!--                        item-text="name"-->
<!--                        item-value="id"-->
<!--                        label=""-->
<!--                        :error-messages="errors"-->
<!--                        :disabled="!filterForm.typeId"-->
<!--                        placeholder="Nhóm ngành"-->
<!--                      />-->
<!--                    </v-row>-->

                    <v-row style="width: 100%; padding: 0px 20px">
                      <v-autocomplete
                        v-model="filterForm.store"
                        :items="stores"
                        item-text="name"
                        item-value="value"
                        label="Chọn kho"
                        placeholder="Chọn kho"
                        clearable
                        @change="changeStore()"
                        @keyup.enter.native="handleSubmit(searchAllotment)"
                      />
                    </v-row>
                    <v-row style="width: 100%; padding: 0px 20px">
                      <v-autocomplete
                        v-model="filterForm.statusIds"
                        :items="contactStatusFilter"
                        item-text="name"
                        item-value="id"
                        label="Chọn nguồn"
                        placeholder="Chọn nguồn"
                        clearable
                        multiple
                        @keyup.enter.native="handleSubmit(searchAllotment)"
                        />
                    </v-row>
                    <div class="text-center">
                      <v-btn
                        class="mx-0"
                        color="rgba(43, 1, 132, 0.5)"
                        @click.prevent="handleSubmit(searchAllotment)">
                        <v-icon>mdi-magnify</v-icon>Tìm kiếm
                      </v-btn>
                    </div>
                  </v-list-item-content>
                </validation-observer>
              </v-list-item>
            </v-card>
          </template>
        </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import TokenService from "@/helpers/token";
import RepositoryFactory from "@/repositories/RepositoryFactory";
const DepartmentRepository = RepositoryFactory.get('department')

export default {
  props: {
    filterForm: {
      type: Object,
      default: () => {}
    },
    listType: {
      type: Array,
      default: () => []
    },
    listSchoolLevel: {
      type: Array,
      default: () => []
    },
    contactStatusList: {
      type: Array,
      default: () => {[]}
    },
  },
  data() {
    return {
      stores: [
        {
            name: 'Kho T',
            value: 'T'
        },
        {
            name: 'Kho C',
            value: 'C'
        },
        {
          name: 'Kho M',
          value: 'M'
        }
      ],
      departmentList: [],
      errors: [],
      contactStatusFilter: []
    }
  },
  created() {
    this.changeStore()
  },
  async mounted() {
    await this.fetchDepartmentList();
  },
  methods: {
    searchAllotment() {
      this.filterForm.openMenu = false
      Bus.$emit('search-allotment-list', this.filterForm)
    },
    clearAssignContact() {
     this.filterForm.clearRecently = true
    },
    async fetchDepartmentList () {
      this.loading = this.$loading.show();

      const response = await DepartmentRepository.listUsers({
        keyword: '',
        status: 'active',
        departmentType: 'retail'
      })
      if (response.error) {
      } else {
        let departmentList = _.get(response, 'data', []).filter(d => _.get(d, 'users', []).length > 0);
        if (!this.isAdmin() && !this.checkAuthorization('schedule_view_all')) {
          const dataUser = TokenService.getUser() || {};
          departmentList = departmentList.filter(d => d.id == dataUser.departmentId  || dataUser.listDepartmentIds.includes(parseInt(d.id)));
        }
        this.departmentList = departmentList;
      }
      this.loading.hide()
    },
    changeStore() {
      let contactStatusFilterTemp = []
      if(this.filterForm.store) {
        let storeStatus = `${this.filterForm.store}0`
        contactStatusFilterTemp = this.contactStatusList.filter(status => status.type.includes(storeStatus))
      } else {
        contactStatusFilterTemp = _.cloneDeep(this.contactStatusList)
      }
      const contactStatusList = [];
      const checkType = {};
      contactStatusFilterTemp.forEach(contactStatus => {
        const typeContactStatus = contactStatus.type;
        if (!checkType[typeContactStatus]) {
          checkType[typeContactStatus] = true;
          if (contactStatusList.length > 0) {
            contactStatusList.push({ divider: true });
          }
          contactStatusList.push({
            header: typeContactStatus,
            style: 'color: red;'
          });
        }
        contactStatus.otherName = `${typeContactStatus.slice(-2)} ${contactStatus.name}`
        contactStatusList.push(contactStatus);
      });
      this.contactStatusFilter = contactStatusList
    },
  },
  watch: {
    contactStatusList: {
      handler () {
        this.changeStore()
      }
    }
  }
}
</script>